































































import Vue from "vue";
import { Component } from "vue-property-decorator";
import { Action, namespace } from "vuex-class";

@Component
export default class LoginView extends Vue {
  @(namespace("auth").Action("login")) actionLogin: any;
  valid: boolean = false;
  e1: boolean = false;
  username: any = "";
  password: any = "";
  emailRules: any = [
    (v: any) => !!v || "E-mail is required",
    (v: any) =>
      /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
      "E-mail must be valid"
  ];
  passwordRules: any = [(v: any) => !!v || "Password is required"];
  alert: boolean = false;
  errorMessage: string | null = null;

  async login() {
    let username = this.username;
    let password = this.password;

    try {
      let results = await this.actionLogin({
        username,
        password
      });

      const { error } = results;
      if (error) {
        this.handleAlertError(error);
      }
    } catch (err) {
      console.log(err);
      this.handleAlertError(err);
    }

    this.$router.push({ path: "/" });
  }

  handleAlertError(msg: string) {
    if (msg) {
      this.alert = true;
      this.errorMessage = msg;
      this.password = "";
    }
  }
}
